import api from './api';

export interface SubTask {
  id: number;
  name: string;
  task_template_id?: number;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  taskTemplate?: {
    id: number;
    name: string;
  };
  task_template?: {
    id: number;
    name: string;
  };
}

export interface CreateSubTaskData {
  name: string;
  task_template_id?: number;
  enabled?: boolean;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const subTaskService = {
  async getAll() {
    const response = await api.get('/sub-tasks');
    return response.data;
  },

  async create(data: CreateSubTaskData): Promise<SubTask> {
    const response = await api.post('/sub-tasks', data);
    return unwrap<SubTask>(response);
  },

  async update(id: number, data: Partial<CreateSubTaskData>): Promise<SubTask> {
    const response = await api.put(`/sub-tasks/${id}`, data);
    return unwrap<SubTask>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/sub-tasks/${id}`);
  },
};

